import cc from 'classcat';
import { observer } from 'mobx-react';
import * as React from 'react';
import { SpeakerObject } from '../stores';
import { AsyncImg } from './AsyncImg';
import { GithubIcon } from './GithubIcon';
import styles from './Speaker.styl';
import { TwitterIcon } from './TwitterIcon';

@observer
export class Speaker extends React.Component<{ speaker: SpeakerObject }> {
    render() {
        const { speaker } = this.props;
        const { photo, twitter, github, name } = speaker;
        return (
            <div className={cc({
                [styles.speaker]: true,
            })}>
                <div className={styles.social}>
                    {github && <a href={`https://github.com/${github}`}><GithubIcon className={styles.socialIcon} /></a>}
                    {twitter && <a href={`https://twitter.com/${twitter}`}><TwitterIcon className={styles.socialIcon} /></a>}
                </div>
                <div className={styles.image}>
                    <AsyncImg srcPromise={photo} />
                </div>
                <div>
                    <p className={styles.name}>{name}</p>
                </div>
            </div>
        );
    }
}

